{
  "it": {
    "common": {
      "description": "Descrizione",
      "email_address_status": {
        "spam_complaint_reactivation": "Qui non è possibile riattivare i reclami per spam. Può essere fatto solo manualmente tramite {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Cerca",
      "selected": "Selezionato",
      "title": "Titolo"
    }
  }
}
